import { notificationFactorGroupBy } from 'helper/GroupBy'
import { ILocationReducer } from 'types/location'
import { LabelValuePer, LondonVariblesTypes } from 'types/notification'
import { ISectorReducer } from 'types/sector'
import { IVariableReducer } from 'types/variable'

export const getVarible = (objects: any[], key: string, value: any) => {
    for (const obj of objects) {
        if (key in obj && obj[key] === value) {
            return obj
        }
    }
    return undefined
}

const listOfVaribles = [
    'types_of_diagnosis',
    'probability',
    'tolerability_analysis',
    'sentinel_event',
    'organizational_consequences'
]
const listOfFactors = [
    'individual_factors_people',
    'patient_factors',
    'team_factors_teams',
    'work_environment_factors',
    'organizational_and_managerial_factors',
    'institutional_context_factors',
    'task_factors_and_technology',
    'technology_and_electronic_information_systems',
    'support_for_patients_families_and_staff',
    'nsp_opinion'
]
export const orderNotificationVarible = (
    listOfData: any,
    shouldOrder: boolean
): LondonVariblesTypes => {
    const items: any = listOfVaribles.map((item) => {
        const listed: LabelValuePer[] = getVarible(
            listOfData,
            'name',
            item
        )?.choices
        const ordered: LabelValuePer[] = shouldOrder ? listed?.sort((o1, o2) =>
            o1.label?.localeCompare(o2.label)
        ) : listed
        return {
            [item]: ordered
        }
    })

    const merged_object: any = {}
    // Loop through each object in the list
    items.forEach((obj) => {
        Object.assign(merged_object, obj)
    })
    return merged_object
}
export const orderNotificationFactor = (listOfData: any) => {
    const items: any = listOfFactors.map((item) => {
        const listed: LabelValuePer[] = notificationFactorGroupBy(
            item,
            listOfData
        )
        const ordered: LabelValuePer[] = listed?.sort((o1, o2) =>
            o1.label?.localeCompare(o2.label)
        )
        return {
            [item]: ordered
        }
    })

    const merged_object: any = {}
    // Loop through each object in the list
    items.forEach((obj) => {
        Object.assign(merged_object, obj)
    })
    return merged_object
}
export function hasNonEmptyValue(obj: any): boolean {
    const keys = Object.keys(obj)
    for (const key of keys) {
        if (key !== 'id' && obj[key]) {
            if (key === 'how_much' && obj[key] === 'R$ 0,00') {
                return false
            }
            return true
        }
    }
    return false
}
export const getVariableFromList = (
    variable: string,
    kind: string,
    variableSelector: IVariableReducer,
    localSelector: ILocationReducer,
    sectorSelector: ISectorReducer
) => {
    switch (kind) {
        case 'incident_type':
            return variableSelector.variablesListIncidentType?.find(
                (v) => v.value === variable
            )?.label
        case 'notification_type':
            return variableSelector.variablesListNotificationType?.find(
                (v) => v.value === variable
            )?.label
        case 'shift_incident':
            return variableSelector.variablesListNotificationTurn?.find(
                (v) => v.value === variable
            )?.label
        case 'damage_level':
            return variableSelector.variablesListDamageLevel?.find(
                (v) => v.value === variable
            )?.label
        case 'location_incident':
            return localSelector.locationsList?.find(
                (v) => v.sys_id === variable
            )?.name
        case 'reporter_sector':
        case 'incident_sector':
            return (
                sectorSelector.sectorsList?.find((v) => v.sys_id === variable)
                    ?.u_name || variable
            )
        default:
            return ''
    }
}
export const getReportMaxDate = (initialDate: any) => {
    let plus30 = new Date(initialDate?.getTime() + (31 * 24 * 60 * 60 * 1000))
    if (plus30?.getTime() > (new Date())?.getTime()) {
      return new Date()
    } else {
      return plus30;
    }
  }
